import type { SVGProps } from "react";
import * as React from "react";

const SvgCameraOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#camera-off_svg__a)">
      <path
        fill="currentColor"
        d="M1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zM21 21v1a1 1 0 0 0 .707-1.707zM1 19H0zM3 6V5zm3 0 .707-.707A1 1 0 0 0 6 5zm3-4a1 1 0 0 0 0 2zm6 1 .832-.555A1 1 0 0 0 15 2zm2 3-.832.555A1 1 0 0 0 17 7zm4 0V5zm1 11.34a1 1 0 1 0 2 0zm-5.895-1.495a1 1 0 1 0-1.65-1.13zm-5.82-5.3a1 1 0 1 0-1.13-1.65zM.293 1.707l22 22 1.414-1.414-22-22zM21 20H3v2h18zM3 20a1 1 0 0 1-.707-.293L.879 21.121A3 3 0 0 0 3 22zm-.707-.293A1 1 0 0 1 2 19H0a3 3 0 0 0 .879 2.121zM2 19V8H0v11zM2 8a1 1 0 0 1 .293-.707L.879 5.879A3 3 0 0 0 0 8zm.293-.707A1 1 0 0 1 3 7V5a3 3 0 0 0-2.121.879zM3 7h3V5H3zm2.293-.293 15 15 1.414-1.414-15-15zM9 4h6V2H9zm5.168-.445 2 3 1.664-1.11-2-3zM17 7h4V5h-4zm4 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 21 5zm.707.293A1 1 0 0 1 22 8h2a3 3 0 0 0-.879-2.121zM22 8v9.34h2V8zm-7.545 6.715a3 3 0 0 1-.955.892l1.014 1.724a5 5 0 0 0 1.591-1.486zm-.955.892a3 3 0 0 1-1.244.401L12.441 18a5 5 0 0 0 2.073-.67zm-1.244.401a3 3 0 0 1-1.296-.165l-.679 1.881a5 5 0 0 0 2.16.276zm-1.296-.165a3 3 0 0 1-1.102-.7l-1.415 1.414a5 5 0 0 0 1.838 1.167zm-1.102-.7a3 3 0 0 1-.701-1.103l-1.881.679a5 5 0 0 0 1.167 1.838zm-.701-1.103a3 3 0 0 1-.165-1.296L7 12.559a5 5 0 0 0 .276 2.16zm-.165-1.296a3 3 0 0 1 .401-1.244l-1.724-1.014A5 5 0 0 0 7 12.56zm.401-1.244a3 3 0 0 1 .892-.955l-1.13-1.65a5 5 0 0 0-1.486 1.591z"
      />
    </g>
    <defs>
      <clipPath id="camera-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCameraOff;
